import styled from "styled-components";

const CardTitle = styled.p`
  font-weight: 500;
  border-left: 3px solid var(--primary-text-color);
  padding-left: 10px;
  margin-bottom: 5px;
`;

export default CardTitle;
